/* eslint-disable react/no-multi-comp, sort-imports */

import React, {useEffect, useState} from "react";
import {Pagination} from "react-bootstrap";
import {buildRange} from "../../../shared/modules/PaginationHelper";
import Helper from "../../../shared/modules/Helper";
import ProductDescriptorsAPI from "../modules/ProductDescriptorsAPI";
import PropTypes from "prop-types";
import Review from "./Review";

const Reviews = ({productDescriptorId}) => {
  const [
    reviews,
    setReviews
  ] = useState([]);

  const [
    currentPage,
    setCurrentPage
  ] = useState(1);

  const [
    totalPages,
    setTotalPages
  ] = useState(0);

  const [
    pageRange,
    setPageRange
  ] = useState([]);

  const fetchReviews = (pageNumber) => {
    ProductDescriptorsAPI.fetchReviews(productDescriptorId, pageNumber).
      then((response) => {
        const {
          "data": {
            page,
            pages,
            "reviews": paginatedReviews
          }
        } = response;
        setReviews(paginatedReviews);
        setCurrentPage(page);
        setTotalPages(pages);
        setPageRange(buildRange(pageNumber, pages));
      });
  };

  const prevPage = () => {
    if (currentPage > 1) {
      fetchReviews(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      fetchReviews(currentPage + 1);
    }
  };

  const buildPaginationItems = () =>
    pageRange.map((page) => {
      if (page === "...") {
        return <Pagination.Ellipsis key={Helper.generateKey()} />;
      }

      return (
        <Pagination.Item
          active={page === currentPage}
          key={page}
          onClick={() => fetchReviews(page)} // eslint-disable-line react/jsx-no-bind
        >
          {page}
        </Pagination.Item>
      );
    });

  const renderPagination = () => {
    if (reviews.length > 0) {
      return (
        <Pagination>
          <Pagination.Prev
            onClick={() => prevPage()} // eslint-disable-line react/jsx-no-bind
          />
          {buildPaginationItems()}
          <Pagination.Next
            onClick={() => nextPage()} // eslint-disable-line react/jsx-no-bind
          />
        </Pagination>
      );
    }

    return null;
  };

  useEffect(() => {
    fetchReviews(1);
  }, [productDescriptorId]);

  return (
    <div className="reviews-container">
      <div>
        {
          reviews.map(review =>
            <Review
              key={Helper.generateKey()}
              review={review}
            />)
        }
      </div>
      <div id="reviews-pagination-container">
        {renderPagination()}
      </div>
    </div>
  );
};

Reviews.propTypes = {"productDescriptorId": PropTypes.number.isRequired};

export default Reviews;
